export const leadsSourceMap = {
  // 1: '广告投放',
  2: '其他',
  3: '外部导入',
  4: '广告创意',
  5: '蹊径落地页',
  6: '枫叶电商落地页',
  7: '一叶智能',
  8: '微信原生推广页',
  9: '讯达小程序',
  10: '云雀',
  11: '樱桃',
  12: '草莓卷',
  13: '栗子通',
  14: '知了',
  15: '果石',
  16: '盘子',
  17: '群友',
  18: '海螺云',
  19: '互动落地页',
  20: '智赢',
  21: '教培通',
  22: '优居',
  23: '亦芯',
  24: '艾推',
  25: '飞鱼',
  26: 'CMS落地页',
};
export const leadsSubSourceMap = {
  301: '外部导入 - 线索平台',
  302: '外部导入 - MKT api',
  303: '外部导入 - 战败线索',
  304: '外部导入 - 爬虫婚摄',
  305: '外部导入 - 爬虫教育',
  306: '外部导入 - 爬虫旅游',
  307: '外部导入 - 爬虫域见增长',
  308: '外部导入 - 爬虫日化服饰',
  309: '外部导入 - 视频号',
  310: '外部导入 - External api',
  900: '讯达小程序 - 未知',
  901: '讯达小程序 - 车讯达',
  902: '讯达小程序 - 鹅房通',
  903: '讯达小程序 - 家讯达',
};
export const xuanjLeadsSubSourceMap = {
  311: '外部导入 - 玄镜QCC',
  312: '外部导入 - 玄镜DD-AD',
  313: '外部导入 - 玄镜DD-DH',
  314: '外部导入 - 玄镜DD-POI',
  315: '外部导入 - 玄镜MM',
  316: '外部导入 - 玄镜DT',
  317: '外部导入 - 玄镜-厚学网',
  318: '外部导入 - 玄镜-高德地图',
  319: '外部导入 - 玄镜-公众号',
  320: '外部导入 - 玄镜-预存1',
  321: '外部导入 - 玄镜-预存2',
  322: '外部导入 - 玄镜-预存3',
};